export default class DtoInstallationAnalysisStats {
    constructor(obj) {
        this.analysisName = obj.analysisName // Option[String],
        this.startDate = obj.startDate // Option[DateTime],
        this.endDate = obj.endDate // Option[DateTime],
        this.nbAnalysis = obj.nbAnalysis // Option[Int]
    }
}